import BigPicture from "bigpicture";

let bigPictureElements = document.querySelectorAll("[data-bp]");

function bigPictureInit() {
    bigPictureElements.forEach((bigPictureElement) => {
        const elementOptions = JSON.parse(bigPictureElement.dataset.bp);
    
        bigPictureElement.addEventListener("click", (e) => {
            let defaultOptions = {
                el: e.target,
                noLoader: true,
            };
    
            if (elementOptions.parentGalleryClass) {
                const galleryImages = document.querySelectorAll(
                    `.${elementOptions.parentGalleryClass} [data-bp]`
                );
    
                let gallery = [];
                galleryImages.forEach((image) => {
                    const imageOptions = JSON.parse(image.dataset.bp);
                    const src = imageOptions.imgSrc;
                    gallery.push({ src });
                });
    
                const position = gallery.findIndex(
                    (item) => item.src === elementOptions.imgSrc
                );
    
                defaultOptions.gallery = gallery;
                defaultOptions.position = position;
            }
    
            BigPicture({
                ...defaultOptions,
                ...elementOptions,
            });
        });
    });
}

// init bit picture elements
bigPictureInit();

/* Media - Request load */
const mediaLoadBtn = document.getElementById('load_media');
const counter = document.getElementById('media-count');
const switch_toggle = document.getElementById('switch');

const mediaContainer_grid = document.getElementById('library-output-grid');
const mediaContainer_row = document.getElementById('library-output-row');

const topics = document.querySelectorAll('[data-mediatopic]');
const categories = document.querySelectorAll('[data-mediacategory]');

//
let mode = 'grid';
let reset = false;
let hasChecks = false;
let checkChanged = false;

// toggle status
function switchStatus() {
    if (switch_toggle.checked === true) {
        mode = 'row';
    } else {
        mode = 'grid';
    }
}

// load more items
function initFilter() {
    var html_lang = document.documentElement.lang;
    // filter items - load items
    var offset, 
        new_offset,
        loadUrl = '/'+html_lang+'/home/apps/load-medias/',
        filterTopics = '',
        filterCategories = '',
        mediaContainer,
        httpRequest = new XMLHttpRequest();

    // get check filters
    topics.forEach(function (topic) {
        if (topic.checked) {
            hasChecks = true;
            if (filterTopics.length > 0) {
                filterTopics += ',';
            }
            filterTopics += topic.dataset.mediatopic;
        }
    })
    categories.forEach(function (cat) {
        if (cat.checked) {
            hasChecks = true;
            if (filterCategories.length > 0) {
                filterCategories += ',';
            }
            filterCategories += cat.dataset.mediacategory;
        }
    })

    if (checkChanged == true) {
        reset = true;
    }

    if (reset === true) {
        offset = 0;
        mediaLoadBtn.classList.remove('d-none');
        mediaContainer_row.innerHTML = "";
        mediaContainer_grid.innerHTML = "";
    } else {
        offset = mediaLoadBtn.dataset.offset;
    }

    // next load for load button
    var load_limit = counter.dataset.limit;
    new_offset = parseInt(offset)+parseInt(load_limit);

    // response
    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        // add new html
        var dataHtml = httpRequest.response;
        var childrenLength, totalItems;
        
        //length children + total items span
        if (mode == 'grid') {
            // add load data
            mediaContainer_grid.innerHTML += dataHtml;
            childrenLength = mediaContainer_grid.children.length;
        } else {
            mediaContainer_row.innerHTML += dataHtml;
            childrenLength = mediaContainer_row.children.length;
        }

        // ausgabe total filter, show, hide button
        var filterTotal = document.getElementById('filtertotal');
        if (filterTotal) {
            totalItems = filterTotal.getAttribute('data-total');
            counter.innerHTML = totalItems;
            // show, hide button
            if (childrenLength > totalItems) {
                mediaLoadBtn.classList.add('d-none');
            } else {
                mediaLoadBtn.setAttribute('data-offset', new_offset);
            }
        }

        // re-init big picutre
        bigPictureElements = document.querySelectorAll("[data-bp]");
        bigPictureInit();

        // back to false
        reset = false;
        checkChanged = false;
      }
    };

    // request
    httpRequest.open('POST', loadUrl, true);
    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    httpRequest.send('offset=' + encodeURIComponent(offset)+'&mode='+ encodeURIComponent(mode)+'&topics='+ encodeURIComponent(filterTopics)+'&categories='+ encodeURIComponent(filterCategories));
}

// filter - filtered output
topics.forEach(function (topic) {
    topic.addEventListener("click", () => {
        checkChanged = true;
        initFilter();
    })
})
categories.forEach(function (cat) {
    cat.addEventListener("click", () => {
        checkChanged = true;
        initFilter();
    })
})

// check for mode status - grid or row
if (switch_toggle) {
    switchStatus();
    switch_toggle.addEventListener('change', function(event){
        reset = true;
        // handle change
        switchStatus();
        initFilter();
    });
}

// load more
if (mediaLoadBtn) {
    // init on load
    initFilter();

    // click event
    mediaLoadBtn.addEventListener('click', function( event ) {
        initFilter()
    });
}
